// extracted by mini-css-extract-plugin
export default {"primaryButton":"styles_primaryButton__78wJy","column_gap_10":"styles_column_gap_10__LZcEH","column_gap_28px":"styles_column_gap_28px__QilDq"};